import React, { useState } from 'react';

// ─── Expand by category ────────────────────────────────────────────────────
// Opened from a root row's ⋯ menu. `options` is [{ label, count }] built from
// the row's DIRECT children — the category rule applies to that first level
// only: a child whose category is ticked gets its whole subtree expanded, one
// whose category is not stays visible but is left collapsed.
//
// This is expansion, not filtering — nothing is hidden either way.
export default function CategoryModal({
  itemName,
  columnTitle = 'Category',
  options,
  onCancel,
  onConfirm,
}) {
  const [selected, setSelected] = useState(() => new Set(options.map((o) => o.label)));

  function toggle(label) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(label)) next.delete(label);
      else next.add(label);
      return next;
    });
  }

  const total = options.reduce(
    (sum, o) => (selected.has(o.label) ? sum + o.count : sum),
    0
  );

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Expand by {columnTitle.toLowerCase()}</h2>
          <button className="modal-close" onClick={onCancel} aria-label="Close">✕</button>
        </div>

        <div className="modal-body">
          <p className="export-modal-bom-name">{itemName}</p>
          <p className="category-modal-hint">
            Pick the {columnTitle.toLowerCase()} values to expand. Direct children in
            an unticked {columnTitle.toLowerCase()} still appear — they are just left
            collapsed.
          </p>

          <div className="col-picker-quick">
            <button
              type="button"
              onClick={() => setSelected(new Set(options.map((o) => o.label)))}
            >
              All
            </button>
            <button type="button" onClick={() => setSelected(new Set())}>
              None
            </button>
          </div>

          <div className="col-check-list category-check-list">
            {options.map((o) => (
              <label key={o.label} className="col-check-item">
                <input
                  type="checkbox"
                  checked={selected.has(o.label)}
                  onChange={() => toggle(o.label)}
                />
                <span className="col-check-label">{o.label}</span>
                <span className="category-check-count">{o.count}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="modal-footer">
          <span className="export-progress-label">
            {total} of {options.reduce((s, o) => s + o.count, 0)} direct children
          </span>
          <button className="btn-secondary" onClick={onCancel}>Cancel</button>
          <button
            className="btn-primary"
            onClick={() => onConfirm(selected)}
            disabled={selected.size === 0}
          >
            Expand
          </button>
        </div>
      </div>
    </div>
  );
}
